const QUOTE_TABLE_CLASSES = {
  CELL_VALUE_UP: 'text-success',
  CELL_VALUE_DOWN: 'text-danger',
  DARK: {
    TABLE: 'table-dark',
  },
};

export default QUOTE_TABLE_CLASSES;
